import { Route, Routes } from 'react-router-dom';
import Layout from '../layouts/Layout';
import Home from '../pages/Home';
import Epitome from '../pages/Epitome';
import Providers from '../pages/Providers';
import Aftercare from '../pages/Aftercare';
import Coverage from '../pages/Coverage';
import AbortionPillsUse from '../pages/AbortionPillsUse';
import CommunityProviders from '../pages/CommunityProviders';
import Contact from '../pages/Contact';

import { default as HomeEs } from '../pages/es/Home';
import { default as ResourcesEs } from '../pages/es/Resources';
import { default as AbortionPillsUseEs } from '../pages/es/AbortionPillsUse';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/global.css';

const LayoutRoutes = () => (
  <Routes>
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="*" element={<Home />} />
      <Route path="what-we-stand-for" element={<Epitome />} />
      <Route path="providers" element={<Providers />} />
      <Route path="aftercare" element={<Aftercare />} />
      <Route path="coverage" element={<Coverage />} />
      <Route path="contact" element={<Contact />} />
      <Route path="how-to-use-abortion-pills" element={<AbortionPillsUse />} />
      <Route
        path="how-to-use-abortion-pills/confirmation/:token"
        element={<AbortionPillsUse />}
      />
      <Route
        path="en-español/acceso-en-los-estados-rojos"
        element={<HomeEs />}
      />
      <Route
        path="en-español/acceso-en-los-estados-rojos"
        element={<HomeEs />}
      />
      <Route path="en-español/recursos" element={<ResourcesEs />} />
      <Route
        path="en-español/como-usar-las-pastillas-para-abortar"
        element={<AbortionPillsUseEs />}
      />
      <Route
        path="who-are-community-providers"
        element={<CommunityProviders />}
      />
    </Route>
  </Routes>
);

export default LayoutRoutes;
